import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./SelectOrderStatus.module.scss";
import { CommonSelectItem } from "../select/CommonSelect";
import { UseFormRegisterReturn } from "react-hook-form";
import { ExpandIcon } from "../../../assets/icons";



type Props = {
	items: SelectOrderStatusItem[];
	placeholder: string;
	onChange: (items: SelectOrderStatusItem | undefined) => void;
};

export class SelectOrderStatusItem {
    key: any;
    label: string;
    isFinal: boolean;

    constructor(key: any, label: string, isFinal: boolean) {
        this.key = key;
        this.label = label;
        this.isFinal = isFinal;
    }
}

class SelectOrderStatusItemInternal {
	key: any;
	label: string;
    isFinal: boolean;
	isSelected: boolean;

	constructor(key: any, label: string, isSelected: boolean, isFinal: boolean) {
		this.key = key;
		this.label = label;
		this.isSelected = isSelected;
        this.isFinal = isFinal;
	}
}

const SelectOrderStatus: React.FC<Props> = memo((props: Props) => {
	const [dropdownExpanded, setDropdownExpanded] = useState(false);
	const { onChange } = props;
    const [items, setItems] = useState<SelectOrderStatusItemInternal[]>([]);

	function changeDropdownState(): void {
		setDropdownExpanded(!dropdownExpanded);
	}

	function close(): void {
		setDropdownExpanded(false);
	}

	function getLabel(): string {
        const selectedItem = getSelectedItem();

		if (selectedItem) {
			return selectedItem.label;
		}
		return props.placeholder;
	}

    function getSelectedItem(): SelectOrderStatusItemInternal | undefined {
        return items.find(i => i.isSelected);
    }

	function selectItem(item: SelectOrderStatusItemInternal): void {
        setItems(items.map(i => {
            if (i.key === item.key) {
                i.isSelected = !i.isSelected;
            } else {
                i.isSelected = false;
            }
            return i;
        }));
        onChange(item);
	}

	function handleMouseDown(event: React.MouseEvent): void {
		event.preventDefault();
	}

	useEffect(() => {
		setItems(props.items.map(item => new SelectOrderStatusItemInternal(item.key, item.label, false, item.isFinal)));
	}, [props.items]);

	return (
		<div className={styles.selectContainer}>
			<div tabIndex={1} className={styles.selectButton} id="select-button" onClick={changeDropdownState} onBlur={close}>
				<span className={styles.text} title={getLabel()}>
					{getLabel()}
				</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="10.536" height="6.506" viewBox="0 0 10.536 6.506">
					<path
						id="ic_keyboard_arrow_left_24px"
						d="M6.506,1.238,2.485,5.268,6.506,9.3,5.268,10.536,0,5.268,5.268,0Z"
						transform="translate(0 6.506) rotate(-90)"
						fill="#000829"
					/>
				</svg>
			</div>
			{dropdownExpanded && (
				<div id="select-dropdown" className={styles.selectExpanded} onMouseDown={handleMouseDown}>
					<div className={styles.selectItems}>
						{items.map((item, index) => {
							return (
								<label key={item.key} className={`${styles.selectItem} ${item.isFinal ? styles.isFinal : undefined}`} onClick={!item.isFinal ? event => {
                                    event.stopPropagation();
                                    selectItem(item);
                                } : undefined }>
									{item.label}
									<input type="checkbox" className={`${styles.inputCheckmark}`} disabled={item.isFinal} checked={item.isSelected || item.isFinal} onChange={!item.isFinal ? event => {
                                        event.stopPropagation();
                                        selectItem(item);
                                    } : undefined} />
								</label>
							);
						})}
					</div>
				</div>
			)}
		</div>
	);
});

export default SelectOrderStatus;
